// import firebase from 'firebase'
import * as firebase from 'firebase/app'
import 'firebase/database' 
import 'firebase/firestore'


var firebaseConfig = {
    apiKey: "AIzaSyBQrjm7M0naTDI4xOi0JUWyd1cgUt9pO8g",
    authDomain: "react-todo-52fa4.firebaseapp.com",
    databaseURL: "https://react-todo-52fa4.firebaseio.com",
    projectId: "react-todo-52fa4",
    storageBucket: "react-todo-52fa4.appspot.com",
    messagingSenderId: "957506503911",
    appId: "1:957506503911:web:de11feca7828488225ce42",
    measurementId: "G-BGYVBPRSV5"
  };
  // Initialize Firebase

  // export const db=firebase.firestore()
  firebase.initializeApp(firebaseConfig);


  // export const auth=firebase.auth()
 export default  firebase
